import config from '../../config';
import Mahjong from './Mahjong';
import PowerUpButton from './PowerUpButton';
import MPUtils from '../../utils/MPUtils';

let soundManager;
let dataManager;

let htpCompleted = false;
let easyCompleted = false;
let easyLevels = [];
let normalLevels = [];
let layout = null;
let levelKey = null;
let fixedHighScore = false;
let replayLevel = false;
// let levelStartScore = 0;
let remainingTiles = 0;

// let adSequence = ['undoButton', 'hintButton', 'bombButton'];
let adSequenceIndex = 1;
let adMatchCounter = 0;
let totalMatchCounter = 0;

let totalLevelsCleared = 0;

class Play extends Phaser.Scene {
  init (data) {
    // console.log('Play.init', data);
    let g = this;
    // console.log('Play.init previous mahjong', g.mahjong);
    soundManager = g.scene.get('SoundManager');
    soundManager.playMusic('loop-main');

    dataManager = g.sys.game.dataManager;
    dataManager.setSessionItem(config.BASE_SCENE, 'Play');

    // start temp collectable override
    // dataManager.setItem('collectables', []);
    // end temp collectable override

    g.endGameStarted = false;
    g.htpActive = false;
    if (g.htp) {
      g.htp = null;
    }

    // dev reset for high score
    // apiManager.setHighScore(0);

    totalMatchCounter = 0;
    g.powerUpUsed = false;

    replayLevel = data.replayLevel;

    if (data.isNewGame) {
      totalLevelsCleared = 0;
      easyCompleted = false;
      easyLevels = _.reverse(_.clone(config.LEVELS.EASY));
    }

    if (replayLevel) {
      g.replay = g.mahjong;
      // create a replay layout based on the previous games remaining active tiles
      g.replay.silentUndo();
      layout = [];
      _.each(g.replay.board, (layer, l) => {
        layout[l] = [];
        let bl = layout[l];
        _.each(layer, (row, r) => {
          bl[r] = [];
          let br = bl[r];
          _.each(row, (tile, c) => {
            if (tile && tile.isActive) {
              br[c] = 1;
            } else {
              br[c] = 0;
            }
          });
        });
      });
      // dataManager.setScore(levelStartScore);
      levelKey = dataManager.getSessionItem('levelKey');
    } else {
      g.replay = null;
      fixedHighScore = data.fixedHighScore;
      if (!htpCompleted) {
        levelKey = config.LEVELS.HTP;
        easyLevels = _.reverse(_.clone(config.LEVELS.EASY));
        if (dataManager.getCoins() < config.STARTING_COINS) {
          // give starting coins
          // console.log('give starting coins');
          dataManager.setCoins(config.STARTING_COINS);
        }
      } else if (!easyCompleted) {
        levelKey = easyLevels.pop();
      } else {
        if (normalLevels.length === 0) {
          normalLevels = _.shuffle(_.clone(config.LEVELS.NORMAL));
        }
        levelKey = normalLevels.pop();
      }

      //levelKey = 'level-39'
    }

    // levelStartScore = dataManager.getScore();

    if (g.replay) {
      // console.log('replay generated layout', layout);
      dataManager.setSessionItem('levelKey', levelKey);
    } else {
      layout = this.cache.json.get(levelKey).layout;
      // console.log('json cached layout', layout);
      dataManager.setSessionItem('levelKey', levelKey);
    }

    this.viewport = new Phaser.Structs.Size(this.scale.width, this.scale.height, this.game.scale.scaleMode);
    this.viewport.setAspectRatio(this.scale.parentSize.aspectRatio);
  }
  create () {
    // console.log('Play.create');
    let g = this;

    g.time.delayedCall(1000, () => {
      soundManager.playSound('vo-game-start');
    });

    g.events.off('resume');
    g.events.on('resume', (a, data) => {
      // console.log('On Play Resume');
      soundManager.resumeMusic();
    });

    g.add.sprite(config.CENTER_X, config.CENTER_Y, 'play-bg');
    this.pauseBtn = g.add.sprite(config.WIDTH - 60, config.CENTER_Y - (Math.min(this.viewport.height, this.scale.height) * 0.5) + 60, 'common');
    this.pauseBtn.setFrame('pause-icon-a.png');
    this.pauseBtn.setInteractive();
    this.pauseBtn.on('pointerdown', () => {
      g.scene.launch('Settings');
    });

    let scoreValue = dataManager.getScore();

    let scoreText = g.add.text(config.CENTER_X, config.CENTER_Y - 430, scoreValue.toLocaleString(), { fontFamily: '"FredBurger Black"', fontSize: 50 +"px", color: "#db433e" }).setOrigin(0.5).setStroke('#000', 3)
    MPUtils.ClampTextToDimensions(scoreText, 400, 1000);

    let highScoreValue = 0;
    if (fixedHighScore === false) {
      highScoreValue = dataManager.getHighScore();
      fixedHighScore = highScoreValue;
    } else {
      highScoreValue = fixedHighScore;
    }
    if (highScoreValue > 0) {

      let bestText = g.add.text(config.CENTER_X, config.CENTER_Y - 395, g.sys.game.localisationManager.GetString("best"), { fontFamily: '"FredBurger Black"', fontSize: 22 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 2)
      MPUtils.ClampTextToDimensions(bestText, 400, 1000);

      let bestScoreText = g.add.text(config.CENTER_X, config.CENTER_Y - 365, highScoreValue.toLocaleString(), { fontFamily: '"FredBurger Black"', fontSize: 38 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 3)
      MPUtils.ClampTextToDimensions(bestText, 400, 1000);
    }

    // TODO: Hook up time event score boost
    g.ticker = 0;
    let t = 0;
    let timeStr = '0:00';

    let timerText = g.add.text(65, config.CENTER_Y -435, timeStr, { fontFamily: '"FredBurger Black"', fontSize: 36 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 3)

    let timeEvent = g.time.addEvent({
      delay: 1000,
      repeat: 3600,
      callback: () => {
        t++;
        g.ticker = t;
        let s = t % 60;
        s = s < 10 ? `0${s}` : s;
        let m = Math.floor(t / 60);
        timeStr = `${m}:${s}`;
        timerText.setText(timeStr);
      }
    });

    // BEAR hint interval
    let bearHintTimer = g.time.addEvent({
      delay: config.BEAR_HINT_INTERVAL,
      loop: true,
      callback: () => {
        g.mahjong.getBearHint();
      }
    });

    // TODO: Hook up coins
    let coinValue = dataManager.getCoins();
    let coin = g.add.sprite(34, config.CENTER_Y - 375, 'common');
    coin.setFrame('coin-a.png');

    let coinText = g.add.text(60, config.CENTER_Y - 375, coinValue.toLocaleString(), { fontFamily: '"FredBurger Black"', fontSize: 36 +"px", color: "#f8df1d" }).setOrigin(0, 0.5).setStroke('#000', 3)

    g.mahjong = new Mahjong(g, layout, g.replay);
    g.replay = null;

    let undoButton = new PowerUpButton(g, config.WIDTH / 3 - 90, config.CENTER_Y + 390, config.UNDO);
    let hintButton = new PowerUpButton(g, config.CENTER_X, config.CENTER_Y + 390, config.HINT);
    let bombButton = new PowerUpButton(g, config.WIDTH - config.WIDTH / 3 + 90, config.CENTER_Y + 390, config.BOMB);

    undoButton.onPurchase = () => {
      g.mahjong.undoMove();
      if (g.mahjong.completedMoves.length === 0) {
        undoButton.purchaseFeedbackDisable();
      } else {
        undoButton.purchaseFeedback();
      }
      soundManager.playSound('undo');
      g.htpCheck();
    };

    hintButton.setActive(true);
    hintButton.onPurchase = () => {
      g.mahjong.getHint();
      if (!g.mahjong.isHintAvailable()) {
        hintButton.purchaseFeedbackDisable();
      } else {
        hintButton.purchaseFeedback();
      }
      soundManager.playSound('hint');
      g.htpCheck();
    };
    remainingTiles = g.mahjong.countRemainingTiles();
    bombButton.setCost(config.COST.bomb * remainingTiles);
    bombButton.setActive(true);
    bombButton.onPurchase = () => {
      g.mahjong.useBomb();
      undoButton.setActive(false);
      hintButton.setActive(false);
      bombButton.purchaseFeedbackDisable();
      soundManager.playSound('bomb');
      g.htpCheck();
    };

    g.powerUpButtonsArray = [undoButton, hintButton, bombButton];
    g.powerUpButtonsArray[adSequenceIndex].setAdActive(true);

    if (levelKey === config.LEVELS.HTP && dataManager.firstTimePlaying) {
      dataManager.firstTimePlaying = false;
      dataManager.saveData();
      g.htpActive = 1;

      g.htpArrows = g.add.sprite(config.CENTER_X, config.CENTER_Y + 200, 'play-sprite');
      g.htpArrows.setFrame('htp-1.png');

      g.htp = g.add.text(config.CENTER_X, config.CENTER_Y + 225, g.sys.game.localisationManager.GetString("instruction_01"), { fontFamily: '"FredBurger Black"', fontSize: 46 +"px", align: 'center', color: "#FFF", wordWrap: { width: 600 } }).setOrigin(0.5).setStroke('#000', 3)
      g.htp.setLineSpacing(-5);
      MPUtils.ClampTextToDimensions(g.htp, g.htp.style.wordWrapWidth, 130);
    }

    // for dev only
    if (__DEV__) {
      g.keys = g.input.keyboard.addKeys('Q');
    }

    // temp
    // g.time.delayedCall(1000, () => {
    //   // g.showReshuffleOption();
    //   // let b = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'bracket');
    //   // b.play('bracket-select');
    //   hintButton.setAdActive(true);
    //   hintButton.onBearClick();
    // });

    g.ui = { coin, coinValue, coinText, scoreValue, scoreText, undoButton, hintButton, bombButton };

    this.scale.on("resize", this.OnResize, this);
  }
  countTileMatch () {
    let g = this;
    adMatchCounter++;
    totalMatchCounter++;
    if (adMatchCounter === 10) {
      adMatchCounter = 0;
      g.powerUpButtonsArray[adSequenceIndex].setAdActive(false);
      adSequenceIndex = adSequenceIndex + 1 < 3 ? adSequenceIndex + 1 : 0;
      g.powerUpButtonsArray[adSequenceIndex].setAdActive(true);
    }
    soundManager.playSound('match');
    if (g.htp && g.htpActive === 1) {
      g.htpActive = 2;
      let tl = g.tweens.createTimeline();
      tl.add({
        targets: [g.htp, g.htpArrows],
        alpha: 0,
        duration: 500,
        onComplete: () => {
          g.htpArrows.setFrame('htp-2.png');

          g.htp.setText(g.sys.game.localisationManager.GetString("instruction_02"));
          g.htp.setFontSize(46);
          g.htp.y -= 60;
          g.htp.setWordWrapWidth(10000);
          MPUtils.ClampTextToDimensions(g.htp, 600, 100);
        }
      });
      tl.add({
        targets: [g.htp, g.htpArrows],
        alpha: 1,
        duration: 500
      });
      tl.play();
    }
  }
  htpCheck () {
    let g = this;
    if (g.htp && g.htpActive === 2) {
      g.htpActive = false;
      g.tweens.add({
        targets: [g.htp, g.htpArrows],
        alpha: 0,
        duration: 500,
        onComplete: () => {
          g.htp.destroy();
          g.htpArrows.destroy();
        }
      });
    }
  }
  changeAdButton () {
    let g = this;
    adMatchCounter = 0;
    g.powerUpButtonsArray[adSequenceIndex].setAdActive(false);
    adSequenceIndex = adSequenceIndex + 1 < 3 ? adSequenceIndex + 1 : 0;
    g.powerUpButtonsArray[adSequenceIndex].setAdActive(true);
  }
  powerUpButtonCheck () {
    let g = this;
    let { undoButton, hintButton, bombButton } = g.ui;
    if (!undoButton.active && g.mahjong.completedMoves.length > 0) {
      undoButton.setActive(true);
    }
    if (!hintButton.active && g.mahjong.isHintAvailable()) {
      hintButton.setActive(true);
    }
  }
  disablePowerUpButtons () {
    let g = this;
    let { undoButton, hintButton, bombButton } = g.ui;
    undoButton.sprite.removeInteractive();
    hintButton.sprite.removeInteractive();
    bombButton.sprite.removeInteractive();
  }
  enablePowerUpButtons () {
    let g = this;
    let { undoButton, hintButton, bombButton } = g.ui;
    undoButton.sprite.setInteractive();
    hintButton.sprite.setInteractive();
    bombButton.sprite.setInteractive();
  }
  showBoardCleared (allBearsFound = false) {
    let g = this;
    let boardsCleared = dataManager.getSessionItem('boardsCleared');
    boardsCleared++;
    dataManager.setSessionItem('boardsCleared', boardsCleared);

    let tape = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'common-tape');
    tape.play('common-tape-animate');

    let message = g.add.text(config.CENTER_X, config.CENTER_Y, g.sys.game.localisationManager.GetString("boxes_cleared"), { fontFamily: '"FredBurger Black"', fontSize: 64 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 3)
    MPUtils.ClampTextToDimensions(message, 400, 500);
    message.setAlpha(0);
    g.tweens.add({
      targets: message,
      alpha: 1,
      duration: 250
    });
    // TODO: Add time bonus
    if (g.ticker <= 60) {
      let points = g.mahjong.tiles.length * 20;
      dataManager.addPoints(points);

      let bonusStr = g.sys.game.localisationManager.GetString("time_bonus");
      bonusStr = bonusStr.replace("<!VALUE>", points.toLocaleString());
      let bonusText = g.add.text(config.CENTER_X, config.CENTER_Y - 150, bonusStr, { fontFamily: '"FredBurger Black"', fontSize: 38 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 3)
      MPUtils.ClampTextToDimensions(bonusText, 500, 500);

      bonusText.setAlpha(0);
      g.tweens.add({
        targets: bonusText,
        alpha: 1,
        duration: 500
      });
    } else if (g.ticker <= 120) {
      let points = g.mahjong.tiles.length * 10;
      dataManager.addPoints(points);
      let bonusStr = g.sys.game.localisationManager.GetString("time_bonus");
      bonusStr = bonusStr.replace("<!VALUE>", points.toLocaleString());
      let bonusText = g.add.text(config.CENTER_X, config.CENTER_Y - 150, bonusStr, { fontFamily: '"FredBurger Black"', fontSize: 38 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 3)
      MPUtils.ClampTextToDimensions(bonusText, 500, 500);
      bonusText.setAlpha(0);
      g.tweens.add({
        targets: bonusText,
        alpha: 1,
        duration: 500
      });
    } else if (g.ticker <= 180) {
      let points = g.mahjong.tiles.length * 5;
      dataManager.addPoints(points);
      let bonusStr = g.sys.game.localisationManager.GetString("time_bonus");
      bonusStr = bonusStr.replace("<!VALUE>", points.toLocaleString());
      let bonusText = g.add.text(config.CENTER_X, config.CENTER_Y - 150, bonusStr, { fontFamily: '"FredBurger Black"', fontSize: 38 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 3)
      MPUtils.ClampTextToDimensions(bonusText, 500, 500);
      bonusText.setAlpha(0);
      g.tweens.add({
        targets: bonusText,
        alpha: 1,
        duration: 500
      });
    }
    g.time.delayedCall(1500, () => {
      if (!htpCompleted) {
        htpCompleted = true;
      }
      if (easyLevels.length === 0) {
        easyCompleted = true;
      }
      dataManager.saveCoins();
      dataManager.checkHighScore();
      g.scene.start('Play', { fixedHighScore: fixedHighScore, replayLevel: false, isNewGame: false });
    });
    soundManager.playSound('tape');
    g.time.delayedCall(300, () => {
      soundManager.playSound('tape');
    });
    g.time.delayedCall(600, () => {
      soundManager.playSound('tape');
    });
    if (g.htp && g.htpActive) {
      g.htpActive = false;
      g.tweens.add({
        targets: [g.htp, g.htpArrows],
        alpha: 0,
        duration: 500,
        onComplete: () => {
          g.htp.destroy();
          g.htpArrows.destroy();
        }
      });
    }
  }
  onNoMovesLeft () {
    let g = this;

    g.disablePowerUpButtons();
    g.mahjong.removeListeners();

    let tape = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'common-tape');
    tape.play('common-tape-animate');

    let message = g.add.text(config.CENTER_X, config.CENTER_Y, g.sys.game.localisationManager.GetString("out_of_moves"), { fontFamily: '"FredBurger Black"', fontSize: 64 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 3)
    MPUtils.ClampTextToDimensions(message, 400, 500);
    message.setAlpha(0);
    g.tweens.add({
      targets: message,
      alpha: 1,
      duration: 250
    });
    g.time.delayedCall(1500, () => {

      g.scene.start('Score');
    });
    soundManager.playSound('tape');
    g.time.delayedCall(300, () => {
      soundManager.playSound('tape');
    });
    g.time.delayedCall(600, () => {
      soundManager.playSound('tape');
    });
  }
  showScoreBonus (txt) {
    let g = this;
    let textBacking = g.add.sprite(config.CENTER_X, config.CENTER_Y - 300, 'play-sprite');
    textBacking.setFrame('text-backing.png');
    textBacking.setAlpha(0);

    let bonusText = g.add.text(config.CENTER_X, config.CENTER_Y - 300, txt.toLocaleString(), { fontFamily: '"FredBurger Black"', fontSize: 38 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 3)
    MPUtils.ClampTextToDimensions(bonusText, 500, 500);
    bonusText.setAlpha(0);
    let tl = g.tweens.createTimeline();
    tl.add({
      targets: [textBacking, bonusText],
      alpha: 1,
      duration: 500
    });
    tl.add({
      targets: [textBacking, bonusText],
      alpha: 0,
      duration: 250,
      delay: 2000
    });
    tl.play();
    return [textBacking, bonusText];
  }
  update () {
    let g = this;
    let { coinValue, coinText, scoreValue, scoreText, undoButton, hintButton, bombButton } = g.ui;

    if (remainingTiles !== g.mahjong.countRemainingTiles()) {
      remainingTiles = g.mahjong.countRemainingTiles();
      bombButton.setCost(config.COST.bomb * remainingTiles);
    }

    if (coinValue !== dataManager.getCoins()) {
      g.ui.coinValue = dataManager.getCoins();
      coinText.setText(g.ui.coinValue.toLocaleString());
    }

    if (scoreValue !== dataManager.getScore()) {
      g.ui.scoreValue = dataManager.getScore();
      scoreText.setText(g.ui.scoreValue.toLocaleString());
    }

    if (__DEV__) {
      if (g.keys.Q.isDown && !g.endGameStarted) {
        g.endGameStarted = true;
        g.onNoMovesLeft();
      }
    }
  }

  OnResize(){
    this.viewport.setAspectRatio(this.scale.parentSize.aspectRatio);
    this.pauseBtn.y = config.CENTER_Y - (Math.min(this.viewport.height, this.scale.height) * 0.5) + 60;
  }
}

export default Play;
